import { createContext } from 'svelte'
import type { Child, DeepReadonly, Person } from '@tadpoles/common'

export type AppContextState = {
    child?: Child
    person?: DeepReadonly<Person>
}

export class AppContext {
    public child = $state.raw<Child | undefined>(undefined)
    public person = $state.raw<DeepReadonly<Person> | undefined>(undefined)

    public constructor(initialState: AppContextState = {}) {
        this.child = initialState.child
        this.person = initialState.person
    }

    public setChild = (child: Child | undefined): Child | undefined => {
        this.child = child
        return this.child
    }

    public setPerson = (
        person: DeepReadonly<Person> | undefined
    ): DeepReadonly<Person> | undefined => {
        this.person = person
        return this.person
    }

    public clearChild = (): undefined => {
        this.child = undefined
        return this.child
    }

    public clear = (): void => {
        this.child = undefined
        this.person = undefined
    }
}

export function createAppContext(initialState: AppContextState = {}): AppContext {
    return new AppContext(initialState)
}

export const [getAppContext, setAppContext] = createContext<AppContext>()

